import { useState } from "react";
import { Menu, X, ChevronDown } from "lucide-react";
import logo from "../assets/image/cclog.png";
import { Link, NavLink } from "react-router-dom";

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [aboutOpen, setAboutOpen] = useState(false);
  const [admissionOpen, setAdmissionOpen] = useState(false);

  return (
    <>
      {/* ================= HEADER ================= */}
      <header className="bg-blue-900 text-white sticky top-0 z-50 shadow-xl">

        {/* ================= TOP BAR ================= */}
        <div className="bg-yellow-400 text-blue-900 overflow-hidden whitespace-nowrap">
          <div className="marquee-container">
            <div className="marquee-content">

              <span>
                🎓 Affiliated to CBSE, Govt. of India, New Delhi —
                Affiliation No. 830890
              </span>

              <span>
                🎓 Affiliated to CBSE, Govt. of India, New Delhi —
                Affiliation No. 830890
              </span>

              <span>
                🎓 Affiliated to CBSE, Govt. of India, New Delhi —
                Affiliation No. 830890
              </span>

              <span>
                🎓 Affiliated to CBSE, Govt. of India, New Delhi —
                Affiliation No. 830890
              </span>

            </div>
          </div>
        </div>

        {/* ================= MAIN HEADER ================= */}
        <div className="max-w-[1500px] mx-auto px-4 xl:px-6">
          <div className="flex items-center justify-between min-h-[82px] gap-4">

            {/* ================= LOGO + SCHOOL NAME ================= */}
            <Link
              to="/"
              className="flex items-center gap-2 flex-shrink-0"
            >
              <img
                src={logo}
                alt="Capitol Public School Logo"
                className="w-16 h-16 xl:w-[68px] xl:h-[68px] object-contain rounded-full bg-white p-1"
              />

              <div className="whitespace-nowrap">
                <h1 className="text-lg xl:text-xl 2xl:text-2xl font-bold text-yellow-400 leading-tight whitespace-nowrap">
                  Capitol Public School
                </h1>

                <p className="text-[10px] xl:text-xs text-gray-300 whitespace-nowrap">
                  Excellence in Education
                </p>
              </div>
            </Link>

            {/* ================= DESKTOP MENU ================= */}
            <nav className="hidden lg:flex items-center justify-end gap-4 xl:gap-5 2xl:gap-7 font-medium text-sm xl:text-[15px] whitespace-nowrap">

              {/* Home */}
              <NavLink
                to="/"
                className={({ isActive }) =>
                  isActive
                    ? "text-yellow-400 font-semibold"
                    : "hover:text-yellow-400 transition"
                }
              >
                Home
              </NavLink>

              {/* ================= ABOUT ================= */}
              <div className="relative group">

                <button className="flex items-center gap-1 hover:text-yellow-400 transition font-medium">
                  About Us
                  <ChevronDown size={15} />
                </button>

                <div className="absolute left-0 top-full pt-3 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-50">

                  <div className="bg-white text-gray-800 w-56 rounded-xl shadow-2xl overflow-hidden border">

                    <Link
                      to="/our-genesis"
                      className="block px-5 py-3 hover:bg-yellow-400 hover:text-blue-900 transition"
                    >
                      Our Genesis
                    </Link>

                    <Link
                      to="/visionaries"
                      className="block px-5 py-3 hover:bg-yellow-400 hover:text-blue-900 transition"
                    >
                      Our Visionaries
                    </Link>

                    <Link
                      to="/why-capitol"
                      className="block px-5 py-3 hover:bg-yellow-400 hover:text-blue-900 transition"
                    >
                      Why Capitol
                    </Link>

                    <Link
                      to="/faculties"
                      className="block px-5 py-3 hover:bg-yellow-400 hover:text-blue-900 transition"
                    >
                      Our Faculties
                    </Link>

                  </div>
                </div>
              </div>

              {/* ================= ACADEMICS ================= */}
              <div className="relative group">

                <button className="flex items-center gap-1 hover:text-yellow-400 transition font-medium">
                  Academics
                  <ChevronDown size={15} />
                </button>

                <div className="absolute left-0 top-full pt-3 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 z-50">

                  <div className="bg-white text-gray-800 w-52 rounded-xl shadow-xl overflow-hidden">

                    <Link
                      to="/code-of-conduct"
                      className="block px-5 py-3 hover:bg-yellow-400 hover:text-blue-900 transition"
                    >
                      CODE OF CONDUCT
                    </Link>

                    <Link
                      to="/curriculum"
                      className="block px-5 py-3 hover:bg-yellow-400 hover:text-blue-900 transition"
                    >
                      CURRICULUM
                    </Link>

                    <Link
                      to="/assessment-plan"
                      className="block px-5 py-3 hover:bg-yellow-400 hover:text-blue-900 transition"
                    >
                      ASSESSMENT PLAN
                    </Link>

                  </div>
                </div>
              </div>

              {/* Infrastructure */}
              <NavLink
                to="/infrastructure"
                className={({ isActive }) =>
                  isActive
                    ? "text-yellow-400 font-semibold"
                    : "hover:text-yellow-400 transition"
                }
              >
                Infrastructure
              </NavLink>

              {/* Admissions */}
              <NavLink
                to="/admissions"
                className={({ isActive }) =>
                  isActive
                    ? "text-yellow-400 font-semibold"
                    : "hover:text-yellow-400 transition"
                }
              >
                Admissions
              </NavLink>

              {/* Careers */}
              <NavLink
                to="/careers"
                className={({ isActive }) =>
                  isActive
                    ? "text-yellow-400 font-semibold"
                    : "hover:text-yellow-400 transition"
                }
              >
                Careers
              </NavLink>

              {/* Gallery */}
              <NavLink
                to="/gallery"
                className={({ isActive }) =>
                  isActive
                    ? "text-yellow-400 font-semibold"
                    : "hover:text-yellow-400 transition"
                }
              >
                Gallery
              </NavLink>

              {/* Contact */}
              <NavLink
                to="/contact"
                className={({ isActive }) =>
                  isActive
                    ? "text-yellow-400 font-semibold"
                    : "hover:text-yellow-400 transition"
                }
              >
                Contact
              </NavLink>

              {/* Apply Now */}
              <NavLink
                to="/contact"
                className="bg-yellow-400 text-blue-900 px-4 xl:px-5 py-2 rounded-full font-bold hover:bg-white transition"
              >
                Apply Now
              </NavLink>

            </nav>

            {/* ================= MOBILE BUTTON ================= */}
            <button
              className="lg:hidden text-white flex-shrink-0"
              onClick={() => setMenuOpen(true)}
              aria-label="Open menu"
            >
              <Menu size={32} />
            </button>

          </div>
        </div>

        {/* ================= MOBILE OVERLAY ================= */}
        <div
          className={`lg:hidden fixed inset-0 bg-black/50 z-40 transition-opacity duration-300 ${
            menuOpen
              ? "opacity-100 visible"
              : "opacity-0 invisible"
          }`}
          onClick={() => setMenuOpen(false)}
        />

        {/* ================= MOBILE SIDEBAR ================= */}
        <div
          className={`lg:hidden fixed top-0 right-0 h-full w-[82%] max-w-sm bg-white z-50 shadow-2xl transform transition-transform duration-300 ${
            menuOpen
              ? "translate-x-0"
              : "translate-x-full"
          }`}
        >

          {/* Mobile Header */}
          <div className="flex justify-between items-center px-6 py-5 border-b">
            <h2 className="text-2xl font-bold text-blue-900">
              Menu
            </h2>

            <button
              onClick={() => setMenuOpen(false)}
              className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center"
              aria-label="Close menu"
            >
              <X size={24} className="text-blue-900" />
            </button>
          </div>

          {/* Mobile Links */}
          <div className="px-6 py-6 space-y-4 overflow-y-auto h-[calc(100%-90px)]">

            {/* Home */}
            <NavLink
              to="/"
              onClick={() => setMenuOpen(false)}
              className="block text-lg font-bold text-blue-900 px-4 py-3 rounded-xl hover:bg-blue-50"
            >
              Home
            </NavLink>

            {/* ================= ABOUT MOBILE ================= */}
            <div className="rounded-xl border overflow-hidden bg-white">

              <button
                onClick={() => setAboutOpen(!aboutOpen)}
                className="w-full flex justify-between items-center px-4 py-3 font-bold text-blue-900"
              >
                About Us

                <ChevronDown
                  size={18}
                  className={`transition duration-300 ${
                    aboutOpen ? "rotate-180" : ""
                  }`}
                />
              </button>

              {aboutOpen && (
                <div className="flex flex-col bg-gray-50 text-blue-800">

                  <Link
                    to="/our-genesis"
                    onClick={() => setMenuOpen(false)}
                    className="px-5 py-3 hover:bg-yellow-100 text-gray-800 font-medium"
                  >
                    Our Genesis
                  </Link>

                  <Link
                    to="/visionaries"
                    onClick={() => setMenuOpen(false)}
                    className="px-5 py-3 hover:bg-yellow-100 text-gray-800 font-medium"
                  >
                    Visionaries
                  </Link>

                  <Link
                    to="/why-capitol"
                    onClick={() => setMenuOpen(false)}
                    className="px-5 py-3 hover:bg-yellow-100 text-gray-800 font-medium"
                  >
                    Why Capitol
                  </Link>

                  <Link
                    to="/faculties"
                    onClick={() => setMenuOpen(false)}
                    className="px-5 py-3 hover:bg-yellow-100 text-gray-800 font-medium"
                  >
                    Faculties
                  </Link>

                </div>
              )}

            </div>

            {/* ================= ACADEMICS MOBILE ================= */}
            <div className="rounded-xl border overflow-hidden bg-white">

              <button
                onClick={() => setAdmissionOpen(!admissionOpen)}
                className="w-full flex justify-between items-center px-4 py-3 font-bold text-blue-900"
              >
                Academics

                <ChevronDown
                  size={18}
                  className={`transition duration-300 ${
                    admissionOpen ? "rotate-180" : ""
                  }`}
                />
              </button>

              {admissionOpen && (
                <div className="flex flex-col bg-gray-50 text-gray-800">

                  <Link
                    to="/code-of-conduct"
                    onClick={() => setMenuOpen(false)}
                    className="px-5 py-3 hover:bg-yellow-100 text-gray-800 font-medium"
                  >
                    Code Of Conduct
                  </Link>

                  <Link
                    to="/curriculum"
                    onClick={() => setMenuOpen(false)}
                    className="px-5 py-3 hover:bg-yellow-100 text-gray-800 font-medium"
                  >
                    Curriculum
                  </Link>

                  <Link
                    to="/assessment-plan"
                    onClick={() => setMenuOpen(false)}
                    className="px-5 py-3 hover:bg-yellow-100 text-gray-800 font-medium"
                  >
                    Assessment Plan
                  </Link>

                </div>
              )}

            </div>

            {/* Infrastructure */}
            <NavLink
              to="/infrastructure"
              onClick={() => setMenuOpen(false)}
              className="block text-lg font-bold text-blue-900 px-4 py-3 rounded-xl hover:bg-blue-50"
            >
              Infrastructure
            </NavLink>

            {/* Admissions */}
            <NavLink
              to="/admissions"
              onClick={() => setMenuOpen(false)}
              className="block text-lg font-bold text-blue-900 px-4 py-3 rounded-xl hover:bg-blue-50"
            >
              Admissions
            </NavLink>

            {/* Careers */}
            <NavLink
              to="/careers"
              onClick={() => setMenuOpen(false)}
              className="block text-lg font-bold text-blue-900 px-4 py-3 rounded-xl hover:bg-blue-50"
            >
              Careers
            </NavLink>

            {/* Gallery */}
            <NavLink
              to="/gallery"
              onClick={() => setMenuOpen(false)}
              className="block text-lg font-bold text-blue-900 px-4 py-3 rounded-xl hover:bg-blue-50"
            >
              Gallery
            </NavLink>

            {/* Contact */}
            <NavLink
              to="/contact"
              onClick={() => setMenuOpen(false)}
              className="block text-lg font-bold text-blue-900 px-4 py-3 rounded-xl hover:bg-blue-50"
            >
              Contact
            </NavLink>

            {/* Apply Now */}
            <NavLink
              to="/contact"
              onClick={() => setMenuOpen(false)}
              className="block text-center bg-yellow-400 text-blue-900 py-4 rounded-full font-bold text-lg mt-4 hover:bg-blue-900 hover:text-white transition"
            >
              Apply Now
            </NavLink>

          </div>
        </div>

      </header>
    </>
  );
}

export default Header;